// Pure helpers for the Square 1-click connect flow. No axios import so Jest
// can load this module (axios v1 ESM breaks CRA5's transform).

export const SQUARE_OAUTH_MESSAGE_TYPE = "zoey-square-oauth";

// Mock authorize page served from public/ while USE_SQUARE_MOCKS is on.
export const MOCK_AUTHORIZE_URL = "/square-oauth-mock.html";

export const maskMerchantId = (id) => {
  if (!id) return "";
  const s = String(id);
  if (s.length <= 8) return s;
  return `${s.slice(0, 4)}…${s.slice(-4)}`;
};
